import React from 'react';
import { Form } from 'reactstrap';

import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import { InputText } from '@/components';
import { FormInputExport } from '../../types';

interface StateProps {
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const ExportContent: React.FC<Props> = ({ formData, formErrors, onChangeFormInput }) => (
  <div className="filter-modal-content">
    <Form noValidate={true} onSubmit={(e): void => e.preventDefault()}>
      <span className="filter-name">Filtrar:</span>

      <InputText
        name="startDate"
        label="Data Inicial"
        placeholder="01/01/2000"
        maxLength={10}
        value={formData[FormInputExport.startDate]}
        onChange={e => onChangeFormInput(FormInputExport.startDate)(e.target.value)}
        error={formErrors.startDate && formErrors.startDate[0]}
      />
      <InputText
        name="endDate"
        label="Data Final"
        placeholder="01/01/2000"
        maxLength={10}
        value={formData[FormInputExport.endDate]}
        onChange={e => onChangeFormInput(FormInputExport.endDate)(e.target.value)}
        error={formErrors.endDate && formErrors.endDate[0]}
      />
    </Form>
  </div>
);
